import React from 'react';

const CityMapBackground = ({ paths, className = '' }) => {
  if (!paths || !paths.length) return null;

  return (
    <g className={`city-map-overlay ${className}`}>
      {paths.map((pathData, index) => (
        <path 
          key={`city-path-${index}`}
          d={pathData}
          fill="rgba(255, 255, 255, 0.1)"
          stroke="#f7b500"
          strokeWidth="4.5"
        />
      ))}
    </g>
  );
};

export default CityMapBackground;